import { createSlice } from "@reduxjs/toolkit";
import { CampaignsInitialStateType } from "./types";

// SAGA FLOW EXAMPLE FOR FUTURE API INTEGRATION

const defaultEndDate = new Date(); // Today
const defaultStartDate = new Date();
defaultStartDate.setDate(defaultEndDate.getDate() - 30);

export const initialState: CampaignsInitialStateType = {
  isLoading: false,
  campaigns: {
    data: [],
    total: 0,
  },
  insights: {
    data: [],
    total: 0,
  },
  adsAccounts: {
    isLoading: false,
    accounts: [],
  },
  campaingsData: {
    isLoading: false,
    campaings: [],
  },
  filter: {
    startDate: null,
    endDate: null,
    dataSource: "All",
    status: "All",
    ad_account_id: null,
    search: "",
  },
  insightFilter: {
    startDate: defaultStartDate,
    endDate: defaultEndDate,
    dataSource: "All",
    group_by: "source_ad_id",
    ad_account_id: null,
    search: "",
  },
  search: "",
  skip: 0,
  campaingsAdCopies: [],
};

const campaigns = createSlice({
  name: "campaignsState",
  initialState,
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setAdsIsLoading(state, action) {
      state.adsAccounts.isLoading = action.payload;
    },
    setCampaigns(state, action) {
      state.campaigns = action.payload;
    },
    setInsights(state, action) {
      state.insights = action.payload;
    },
    setAdsAccounts(state, action) {
      state.adsAccounts.accounts = action.payload;
    },
    setCampaignFilter(state, action) {
      state.filter = action.payload;
    },
    setInsightFilter(state, action) {
      state.insightFilter = action.payload;
    },
    setCampaignSkip(state, action) {
      state.skip = action.payload;
    },
    setCampaignSearch(state, action) {
      state.search = action.payload;
    },
    setCampaingsAdCopies(state, action) {
      state.campaingsAdCopies = action.payload;
    },
  },
});

export const {
  actions: CampaignsReducerAction,
  name: CampaignsReducerName,
  reducer: CampaignsReducer,
} = campaigns;
